import Criticality from '../../icons/findings/Criticality'
import CriticalityNoRestriction from '../../icons/findings/CriticalityNoRestriction'
import IconProps from '../../icons/Icon'
import { ALWAYS_RESTRICTED_LEVELS, chooseIconColor } from '../../lib/findings'
import { getSize } from '../../theme/iconSizes'
import { Status } from '../create-defect/types'

interface RestrictionInfoProps {
  criticality: string
  usageCode: string | null
  nightMode: boolean
  status: Status
  iconSize?: IconProps['iconSize']
}

const RestrictionIcon = ({
  criticality,
  usageCode,
  nightMode,
  status,
  iconSize = 'huge',
}: RestrictionInfoProps) => {
  const isRestrictive = !!(
    (criticality && ALWAYS_RESTRICTED_LEVELS.includes(criticality)) ||
    (criticality === '3' && usageCode)
  )

  const size = getSize(iconSize)
  const { fillColor, strokeColor, fillColorSecondary, strokeColorSecondary } = chooseIconColor(
    criticality,
    isRestrictive,
    status,
    nightMode
  )

  return (
    <div style={{ height: size }}>
      {isRestrictive ? (
        <Criticality
          iconSize={size}
          fillColor={fillColor}
          stroke={strokeColor}
          fillColorSecondary={fillColorSecondary}
          strokeColorSecondary={strokeColorSecondary}
        />
      ) : (
        <CriticalityNoRestriction iconSize={size} fillColor={fillColor} stroke={strokeColor} />
      )}
    </div>
  )
}

export default RestrictionIcon
